const rankings = [
  { rank: 1, badge: '🔥', title: '某知名网红深夜直播翻车全过程曝光', heat: 98520, tag: '网红翻车' },
  { rank: 2, badge: '🔥', title: '娱乐圈顶流艺人隐婚生子细节流出', heat: 87430, tag: '明星八卦' },
  { rank: 3, badge: '🔥', title: '某互联网大厂高管内部聊天记录外泄', heat: 76210, tag: '社会事件' },
  { rank: 4, badge: '📈', title: '综艺节目录制现场冲突片段引热议', heat: 65890, tag: '娱乐爆料' },
  { rank: 5, badge: '📈', title: '热门影视剧幕后资本运作关系网深扒', heat: 54120, tag: '深度扒皮' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热度<span className="text-primary-500">榜单</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              实时更新 · 全网最热911吃瓜黑料事件排行
            </p>
          </div>

          <div className="space-y-3">
            {rankings.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-4 bg-background-100 rounded-xl px-5 py-4 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  idx < 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-200 text-secondary-700'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm">{item.badge}</span>
                    <span className="text-sm md:text-base font-medium text-foreground-950 truncate">
                      {item.title}
                    </span>
                  </div>
                </div>
                <span className="px-2.5 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
                  <i className="ri-fire-line text-accent-500"></i>
                  <span>{(item.heat / 10000).toFixed(1)}万热度</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}